/**
 * Demo-environment detection.
 *
 * The separate demo stack (demo.sentrysolutions.info) is built with
 * `VITE_IS_DEMO=true` so the bundle knows it is the prospect-facing demo and
 * can enable demo-only affordances (e.g. the auto-running guided sales tour).
 *
 * Read at call time (not a module-load constant) so it can be stubbed in tests
 * via `vi.stubEnv('VITE_IS_DEMO', 'true')`. Vite statically replaces
 * `import.meta.env.VITE_IS_DEMO` at build time, so this is also tree-shake/
 * inline-friendly in production builds.
 */
export function isDemoMode(): boolean {
  return import.meta.env.VITE_IS_DEMO === 'true';
}
